
















































import Vue from 'vue'
import moment from 'moment'
import { TranslateResult } from 'vue-i18n'
import { PlanningAssistantPeriodicityPayload } from '@/types/payload'
import { CALENDAR_EVENT_ASSISTANT_SET_PERIODICITY } from '@/store/action-types'
import {
  CALENDAR_EVENT_ASSISTANT_GET_END_DATE,
  CALENDAR_EVENT_ASSISTANT_GET_IS_EDITING_SERIE,
  CALENDAR_EVENT_ASSISTANT_GET_START_DATE,
  GET_SELECTED_UI_LANGUAGE
} from '@/store/getter-types'
import { CalendarEvent } from '@/model/planning/CalendarEvent'
import { CalendarEventSerie } from '@/types/service-response'

interface ComponentData {
  isUnique: boolean,
  weekDayList: Array<DayListItem>
  selectedWeekDayList: Array<number>

  repeatEveryNthWeek: number
  expireAfterRepetitions: number
  expireAfterDateIso: string | undefined
}

interface DayListItem {
  number: number
  day: TranslateResult
}

export default Vue.extend({
  name: 'CalendarEventEditorPeriodicity',

  props: {
    editCalendarEvent: Object as () => CalendarEvent | undefined,
    editCalendarEventSerie: Object as () => CalendarEventSerie | undefined,
  },

  data (): ComponentData {
    return {
      isUnique: true,

      weekDayList: [
        {
          day: this.$t('planningPage.monday'),
          number: 1
        },
        {
          day: this.$t('planningPage.tuesday'),
          number: 2
        },
        {
          day: this.$t('planningPage.wednesday'),
          number: 3
        },
        {
          day: this.$t('planningPage.thursday'),
          number: 4
        },
        {
          day: this.$t('planningPage.friday'),
          number: 5
        },
        {
          day: this.$t('planningPage.saturday'),
          number: 6
        },
        {
          day: this.$t('planningPage.sunday'),
          number: 7
        },
      ],

      selectedWeekDayList: [],

      repeatEveryNthWeek: 1,
      expireAfterRepetitions: 0,
      expireAfterDateIso: undefined
    }
  },

  computed: {
    expireAfterDateFormatted: {
      get (): string | undefined {
        if (this.expireAfterDateIso) {
          return moment(this.expireAfterDateIso).format('DD.MM.YYYY')
        }
        return undefined
      },

      set (): void {
        this.expireAfterDateIso = undefined
        this.updateStoreValues()
      }
    },

    isEnabled (): boolean {
      return this.isUnique
    },

    isEdittingCalendarEvent (): boolean {
      return !!this.editCalendarEvent
    },

    isEdittingSerie (): boolean {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_IS_EDITING_SERIE]
    },

    selectedLocale(): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    isPeriodicityDisabled (): boolean {
      const dateStart: Date = this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_START_DATE]
      const dateEnd: Date = this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_END_DATE]

      if(moment(dateStart).format('DD:MM:YYYY') === moment(dateEnd).format('DD:MM:YYYY')) {
        return false
      } else {
        this.resetState()
        return true
      }

    }
  },

  watch: {
    isUnique (newVal: boolean): void {
      if (newVal) {
        this.resetState()
      }

      this.updateStoreValues()
    }
  },

  methods: {
    onFieldValueChange (): void {
      this.updateStoreValues()
    },

    updateStoreValues (): void {
      const payload: PlanningAssistantPeriodicityPayload = {
        isUnique: this.isUnique,
        weekDayList: this.selectedWeekDayList,
        repeatEveryNthWeek: this.repeatEveryNthWeek,
        expireAfterRepetitions: this.expireAfterRepetitions,
        expireAfterDate: this.expireAfterDateIso && moment(this.expireAfterDateIso).toDate() || undefined
      }

      this.$store.dispatch(CALENDAR_EVENT_ASSISTANT_SET_PERIODICITY, payload)
    },

    resetState (): void {
      if(this.editCalendarEventSerie) {
        let days: Array<number> = []
        if(this.editCalendarEventSerie.Montag){
          days.push(1)
        }
        if(this.editCalendarEventSerie.Dienstag){
          days.push(2)
        }
        if(this.editCalendarEventSerie.Mittwoch){
          days.push(3)
        }
        if(this.editCalendarEventSerie.Donnerstag){
          days.push(4)
        }
        if(this.editCalendarEventSerie.Freitag){
          days.push(5)
        }
        if(this.editCalendarEventSerie.Samstag){
          days.push(6)
        }
        if(this.editCalendarEventSerie.Sonntag){
          days.push(7)
        }

        this.isUnique = this.editCalendarEventSerie.Einmalig
        this.selectedWeekDayList = days
        this.repeatEveryNthWeek = this.editCalendarEventSerie.Wiederholungs
        this.expireAfterRepetitions = this.editCalendarEventSerie.EndAfternTimes
        this.expireAfterDateIso = this.editCalendarEventSerie.EndAfterDate!
      } else {
        this.isUnique = true
        this.selectedWeekDayList = []
        this.repeatEveryNthWeek = 1
        this.expireAfterRepetitions = 0
        this.expireAfterDateIso = undefined
      }
    }
  },

  mounted (): void {
    this.resetState()
  }
})
